import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('theme-1');
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem('hms-theme') || 'theme-1';
    const savedMode = localStorage.getItem('hms-dark-mode') === 'true';
    setTheme(savedTheme);
    setIsDarkMode(savedMode);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);
    
    if (isDarkMode) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }

    localStorage.setItem('hms-theme', theme);
    localStorage.setItem('hms-dark-mode', isDarkMode);
  }, [theme, isDarkMode]);

  const toggleDarkMode = () => setIsDarkMode(prev => !prev);
  const changeTheme = (newTheme) => setTheme(newTheme);

  return (
    <ThemeContext.Provider value={{ theme, isDarkMode, toggleDarkMode, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};